module.exports = __webpack_public_path__ + "img/FQA.0861127c.png";